import { driversActions } from '../reducer';

type Operation = () => void;

export const resetDeletingDriverFuelAssignmentStatus: Operation = () => driversActions.setDeletingDriverFuelAssignmentStatus();
